<template>
  <module-card
    v-bind="params"
    :permissions="permissions"
    :loading="loading"
    :retryFunction="retryFunction"
    :errorText="enums.responses.error"
    :segmentations="segmentations"
    @visibleChanged="$emit('visibleChanged', $event)"
  >
    <template slot="content">
      <div v-if="items.length == 0" class="product-docs">
        <div class="product-docs__blocked">
          <div class="product-docs__blocked__container">
            <i class="bexsicon-calendar product-docs__blocked__icon"></i>
            <div class="product-docs__blocked__info">
              <span>
                <b>Manual do proprietário indisponível.</b>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="product-docs__container">
        <v-layout align-center justify-space-around row fill-height>
          <v-layout
            v-for="(info, index) in infoBlocks"
            :key="index"
            align-center
            justify-center
            column
            class="product-docs__block"
          >
            <i class="product-docs__block__icon" :class="info.icon"></i>
            <div class="product-docs__block__info">
              <span>
                <b>{{ info.text }}</b>
              </span>
            </div>
          </v-layout>
        </v-layout>
      </div>
    </template>
    <template slot="actions" v-if="items.length > 0 && items[0].attachment">
      <form method="POST" :action="items[0].attachment" target="_blank">
        <input type="hidden" name="idemp" :value="selectedUnit.product.code" />
        <input type="hidden" name="torre" :value="selectedUnit.block.code" />
        <input type="hidden" name="unidade" :value="selectedUnit.unit.code" />
        <v-btn
          class="slin-btn"
          type="submit"
          @click="previewFile(items[0], 'owner')"
          :style="{ color: params.themeColor }"
        >
          <i class="bexsicon-docs-sm" />
          {{ $t('pages.documents.productDocsCardAction') }}
        </v-btn>
      </form>
    </template>
  </module-card>
</template>

<script>
import ModuleCard from '@/components/layout/Card';
import { DOCS, PROFILES, UNIT, SEGMENTATIONS } from '../../utils/constants';
export default {
  components: {
    ModuleCard,
  },
  computed: {
    segmentations() {
      const hasOwnerDocs = this.$store.getters[DOCS.HAS_OWNER_DOCS];

      if (hasOwnerDocs) {
        if (this.$store.getters[UNIT.GET_IS_KEY_DELIVERED]) {
          return [
            SEGMENTATIONS.ASSOCIATIVE__REHEARSE_STATUS,
            SEGMENTATIONS.ASSOCIATIVE_REHEARSED__REHEARSE_STATUS,
            SEGMENTATIONS.SFH__REHEARSE_STATUS,
            SEGMENTATIONS.SETTLED__REHEARSE_STATUS,
            SEGMENTATIONS.DIRECT__REHEARSE_STATUS,
            SEGMENTATIONS.INDIRECT__USER_ROLE,
            SEGMENTATIONS.KEYS_DELIVERED__CONSTRUCTION_STAGE,
          ];
        } else {
          return [
            SEGMENTATIONS.INDIRECT__USER_ROLE,
            SEGMENTATIONS.IN_CONSTRUCTION__CONSTRUCTION_STAGE,
            SEGMENTATIONS.DELIVERED__CONSTRUCTION_STAGE,
          ];
        }
      }
    },
    items() {
      return this.$store.getters[DOCS.GET_OWNER_DOCS];
    },
  },
  data() {
    return {
      permissions: [
        PROFILES.ADMIN_PROFILE,
        PROFILES.ADMIN_BEXS_PROFILE,
        PROFILES.ADMIN_HR_PROFILE,
        PROFILES.HR_PROFILE,
      ],
      infoBlocks: this.$t('pages.documents.productDocsCardInfos'),
    };
  },
  props: {
    lastUpdate: String,
    stage: String,
    loading: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      required: true,
    },
    retryFunction: Function,
  },
  methods: {
    previewFile({ title, attachment, _id }, type) {
      const action = this.enums.logTraceActions[`${type}DocsDownload`];
      this.createTrace(action, { title, attachment });
    },
  },
};
</script>

<style lang="scss" scoped>
.product-docs {
  &__container {
    display: flex;
  }

  &__block {
    background-color: #f5f5f5;
    height: 100px;
    margin-left: 3px;
    margin-right: 3px;
    border-radius: 8px;

    &__icon {
      color: #aaaaaa;
      align-content: center;
      font-size: 3.5rem;
    }
    &__info {
      font-size: 12px;
      margin: 10px 5px 0px;
      text-align: center;
    }
  }

  &__blocked {
    display: block;
    height: 100%;
    background: #f1f1f1;
    border-radius: 4px;
    color: var(--label-color);

    &__container {
      display: flex;
      padding: 20px;
      height: 150px;
    }

    &__info {
      font-size: 11px;
      flex: 0.85;
      margin: auto 5px;
    }

    &__icon {
      flex: 0.1;
      color: var(--grey-icon-color);
      font-size: 2.5rem;
      background: #fff;
      border-radius: 50px;
      padding: 10px;
      margin-top: auto;
      margin-bottom: auto;
      margin-left: 1.2rem;
      margin-right: 0.5rem;
    }
  }
}

.product-docs-list {
  display: block;
  list-style: none;

  &__item {
    display: flex;
    padding-bottom: 10px;
    margin-bottom: 10px;

    &:not(:last-child) {
      border-bottom: 1px solid #eee;
    }
  }

  &__item-date {
    flex: 40px 0 0;
    text-align: center;
    font-weight: bold;
    margin-right: 10px;
  }

  &__item-hour {
    font-weight: bold;
    margin: 0;
  }

  &__item-title {
    font-size: 14px;
  }

  &__item-place {
    font-size: 12px;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/modules/ProductDocsCard.vue